import GridRowViewToggler from "../UI/GridRowViewToggler";
import { SortControl } from "components/controls";
import { ToggleButton } from "components/buttons";

import "./FeedControl.scss";
import { useCallback } from "react";

const SORT_OPTIONS = {
  trending: "Trending",
  top: "Top",
  new: "Latest",
  old: "Oldest",
};

const SORT_TOP_OPTIONS: {[key: string]: string} = {
  top7: "This week",
  top28: "This month",
  best: "All Time",
};

interface IProps {
  order: string;
  ordering?: boolean;
  orderingTop?: boolean;
  tiles: boolean;
  verified?: boolean;
  changeOrder: (value: string) => void;
  changeMode: (tiles: boolean) => void;
  changeVerified?: (verified: boolean) => void;
}

export const FeedControl = (props: IProps) => {
  const {
    order,
    ordering,
    orderingTop,
    tiles,
    verified,
    changeOrder,
    changeMode,
    changeVerified
  } = props;

  const onModeToggle = useCallback(() => {
    changeMode(!tiles);
  }, [changeMode, tiles]);

  const onVerifiedToggle = useCallback((value: boolean) => {
    changeVerified && changeVerified(value);
  }, [changeVerified]);

  const onChangeOrder = useCallback((value: string) => {
    const newValue = value === "top" && orderingTop ? "best" : value;
    changeOrder(newValue);
  }, [changeOrder, orderingTop]);

  return (
    <div className="feedControl">
      <div className="ordering">
        {ordering && <SortControl
          order={SORT_TOP_OPTIONS[order] ? "top" : order}
          options={SORT_OPTIONS}
          onChange={onChangeOrder}
        />}

        {ordering && orderingTop && SORT_TOP_OPTIONS[order] && <SortControl
          label={""}
          order={order}
          options={SORT_TOP_OPTIONS}
          onChange={onChangeOrder}
        />}
      </div>

      {changeVerified && <div className="verified">
        <ToggleButton
          className="small right"
          label="Verified only"
          checked={!!verified}
          onChange={onVerifiedToggle}
        />
      </div>}

      <div className="tiling">
        <GridRowViewToggler rowView={!tiles} toggleFn={onModeToggle} />
      </div>
    </div>
  );
};
